const KnowledgeGraph = () => import('Views/knowledge-graph/index-new-ui');
const KnowledgeGraphHome = () => import('Views/knowledge-graph/home');
const TimeDistribution = () => import('Views/knowledge-graph/time-distribution-5-1');
const Partner = () => import('Views/knowledge-graph/partner-4-1');
const Institution = () => import('Views/knowledge-graph/institution');
const Country = () => import('Views/knowledge-graph/country-gl-1-1');
const KeywordsTimeDistribution = () => import('Views/knowledge-graph/keywords-time-distribution-7-1');
const InternationalCooperationDynamics = () => import('Views/knowledge-graph/international-cooperation-dynamics');
const ResearchPersonnelRelations = () => import('Views/knowledge-graph/research-personnel-relations');
const InternationalSituationAnalysis = () => import('Views/knowledge-graph/international-situation-analysis');
const DomesticSituationAnalysis = () => import('Views/knowledge-graph/domestic-situation-analysis');

export default[
  { path: '/knowledge-graph',
    component: KnowledgeGraph,
    children: [
      { path: '/knowledge-graph', component: KnowledgeGraphHome },
      { path: '/knowledge-graph/time-distribution', component: TimeDistribution },
      { path: '/knowledge-graph/partner', component: Partner },
      { path: '/knowledge-graph/institution', component: Institution },
      { path: '/knowledge-graph/country', component: Country },
      { path: '/knowledge-graph/keywords-time-distribution', component: KeywordsTimeDistribution },
      { path: '/knowledge-graph/international-cooperation-dynamics', component: InternationalCooperationDynamics },
      { path: '/knowledge-graph/research-personnel-relations', component: ResearchPersonnelRelations },
      { path: '/knowledge-graph/international-situation-analysis', component: InternationalSituationAnalysis },
      { path: '/knowledge-graph/domestic-situation-analysis', component: DomesticSituationAnalysis },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/knowledgeGrap.js